const openSideCart = () => {
  if (window.location.href.indexOf("?cartopen=true") > -1) {
    setTimeout(() => {
      window.setState('cartOpen', true);
      const sideCart = document.querySelector("#CartDrawerContainer");
      sideCart.classList.add("active");
    }, 3000);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  openSideCart();
});